var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$store.state.recipe.image)?_c('div',{class:{
        collapsed: _setup.collapsed,
        printable: _vm.$store.state.recipe.printImage,
    }},[_c('img',{attrs:{"alt":_vm.t('cookbook', 'Recipe image'),"src":_vm.$store.state.recipe.imageUrl},on:{"click":function($event){return _setup.toggleCollapsed()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }